import {Directive, ElementRef, EventEmitter, HostListener, Input, Output} from "@angular/core";
import {isNullOrUndefined} from "util";
import {padRight} from "../../services/common";

@Directive(
  {selector:"[assrNumber]"}
)
export class AssrNumber {
  @Input() value: string;
  @Input() formatType: string;
  @Input() pattern: string;
  @Input() size: number;
  @Output() apply: EventEmitter<any> = new EventEmitter<any>();
  private formattedValue: string;
  private controlName: string;

  constructor(private el: ElementRef) {}

  @HostListener("keyup", ["$event"]) smeet(event: KeyboardEvent) {

    let acceptableKeys = [
      {key:"0", keyCode:96},
      {key:"1", keyCode:97},
      {key:"2", keyCode:98},
      {key:"3", keyCode:99},
      {key:"4", keyCode:100},
      {key:"5", keyCode:101},
      {key:"6", keyCode:102},
      {key:"7", keyCode:103},
      {key:"8", keyCode:104},
      {key:"9", keyCode:105},
      {key:".", keyCode:110},
      {key:"1", keyCode:49},
      {key:"2", keyCode:50},
      {key:"3", keyCode:51},
      {key:"4", keyCode:52},
      {key:"5", keyCode:53},
      {key:"6", keyCode:54},
      {key:"7", keyCode:55},
      {key:"8", keyCode:56},
      {key:"9", keyCode:57},
      {key:"0", keyCode:48},
      {key:".", keyCode:190},
      {key:"ArrowLeft", keyCode:37},
      {key:"ArrowDown", keyCode:40},
      {key:"ArrowRight", keyCode:39},
      {key:"ArrowUp", keyCode:38},
      {key:"Backspace", keyCode:8},
      {key:"Delete", keyCode:46}
    ];
    // if (acceptableKeys.map(kee => { return kee.keyCode; }).indexOf(event.keyCode) == -1) {
    //   return false;
    // }

    let _val = null;
    this.controlName = this.el.nativeElement.attributes["formControlName"].value;

    switch (this.formatType) {
      case"currency":
        _val = parseInt(this.el.nativeElement.value.replace(/[^\d]+/g, ""));

        this.formattedValue = isNaN(_val)?null:_val.toLocaleString("en-US", {style:"currency", currency:"USD"}).split(".")[0];
        break;
      case"number":
        _val = parseInt(this.el.nativeElement.value.replace(/[^\d]+/g, ""));
        this.formattedValue = isNaN(_val)?null:_val.toLocaleString();
        break;
      case"decimal":
        //_val = this.el.nativeElement.value.endsWith(".") ? this.el.nativeElement.value + "0" : this.el.nativeElement.value;
        _val = this.el.nativeElement.value.match(/(([\d]{1,3}(,)?)+)(\.[\d]{1,2})?/);
        this.formattedValue = isNaN(_val)?null:_val[0].toLocaleString();
        break;
      case"year":
        _val = parseInt(this.el.nativeElement.value.replace(/[^\d]+/g, ""));
        this.formattedValue = isNaN(_val)?null:_val.toString().substring(0, 4);
        break;
      case"spn":
        let _spn: Array<string> = [];
        _val = this.el.nativeElement.value.replace(/[^\d]+/g, "");
        _spn[0] = _val.substr(0, 4);
        _spn[1] = _val.substr(4, 3);
        _spn[2] = _val.substr(7, 3);
        _spn[3] = _val.substr(9, 3);

        this.formattedValue = _spn.join("-");
        break;
      default:
        _val = parseInt(this.el.nativeElement.value.replace(/[^\d]+/g, ""));
        this.formattedValue = isNaN(_val)?null:_val.toLocaleString();
        break;
    }

    this.apply.emit({value:this.formattedValue, control:this.controlName});
  }

  @HostListener("onFocus") onFocus() {
    this.el.nativeElement.select();
  }

  get() {
    return parseInt(this.el.nativeElement.value.replace(/[^\d]+/g, "")) || null;
  }

}
